import { Reveal } from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import { WHAT_WE_PAINT } from "@/data";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-ice py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <Reveal>
        <p className="font-primary uppercase tracking-[0.3em] text-navy/50 text-xs md:text-sm mb-4">Services</p>
        <h2 className="font-primary font-bold uppercase tracking-tighter text-navy text-5xl md:text-7xl leading-[0.9] mb-14 md:mb-20">
          What We Paint
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 gap-x-16">
        {WHAT_WE_PAINT.map((item, i) => {
          const isLast = i === WHAT_WE_PAINT.length - 1;
          return (
            <Reveal key={item} delay={(i % 2) * 0.06}>
              <a
                href="#quote"
                data-testid={`paint-item-${i}`}
                className="group flex items-center justify-between gap-4 border-t border-navy/15 py-7 md:py-8 transition-colors hover:text-gold"
              >
                <span className={`font-primary font-semibold uppercase tracking-tight text-2xl md:text-3xl ${isLast ? "text-gold" : "text-navy group-hover:text-gold"} transition-colors`}>
                  {item}
                </span>
                <ArrowRight size={24} className="text-navy/40 group-hover:text-gold group-hover:translate-x-1 transition-all shrink-0" />
              </a>
            </Reveal>
          );
        })}
        <div className="border-t border-navy/15" />
      </div>
    </div>
  </section>
);
